module.exports = __webpack_public_path__ + "static/media/digital-marketing-icon.a0c9386e.svg";